import type { ControlsFactory, JSReportDesigner, XRSubreportViewModel } from 'devexpress-reporting/dx-reportdesigner'
import { rootUrl } from './componentApi';

const injectIcon = (id: string, svg: string) => {
    if (!document.getElementById(id)) {
        const template = document.createElement('script');
        template.type = 'text/html';
        template.id = id;
        template.innerHTML = svg;
        template.setAttribute('ich-ignore', 'true');
        document.head.appendChild(template);
    }
}

export const ensureIcons = () => {
    injectIcon('enable-overlap-detection', `
        <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512" style="fill: #606060;">
            <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
            <path class="dxd-icon-fill" d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"/>
        </svg>
    `);

    injectIcon('format-paint', `
        <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 384 512" style="fill: #606060">
            <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
            <path d="M162.4 6c-1.5-3.6-5-6-8.9-6h-19c-3.9 0-7.5 2.4-8.9 6L104.9 57.7c-3.2 8-14.6 8-17.8 0L66.4 6c-1.5-3.6-5-6-8.9-6H48C21.5 0 0 21.5 0 48V224v22.4V256H9.6 374.4 384v-9.6V224 48c0-26.5-21.5-48-48-48H230.5c-3.9 0-7.5 2.4-8.9 6L200.9 57.7c-3.2 8-14.6 8-17.8 0L162.4 6zM0 288v32c0 35.3 28.7 64 64 64h64v64c0 35.3 28.7 64 64 64s64-28.7 64-64V384h64c35.3 0 64-28.7 64-64V288H0zM192 432a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"/>
        </svg>
    `)

    injectIcon('edit-data-source', `
        <svg width="32px" height="32px" viewBox="0 0 32 32" id="icon" xmlns="http://www.w3.org/2000/svg" style="fill: #606060;">
            <defs>
                <style>
                .cls-1 {
                    fill: none;
                }
                </style>
            </defs>
            <path  class="dxd-icon-fill"  d="M28,2H20a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2h8a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,2v7H20V4Zm0,9v6H20V13ZM20,28V21h8v7Z"/>
            <polygon  class="dxd-icon-fill"  points="12 15 10 15 10 13 8 13 8 15 6 15 6 17 8 17 8 19 10 19 10 17 12 17 12 15"/>
            <path  class="dxd-icon-fill"  d="M16,6V4H10A2.0023,2.0023,0,0,0,8,6V9.08A6.99,6.99,0,0,0,8,22.92V26a2.0023,2.0023,0,0,0,2,2h6V26H10V22.92A6.99,6.99,0,0,0,10,9.08V6ZM14,16a5,5,0,1,1-5-5A5.0059,5.0059,0,0,1,14,16Z"/>
            <rect id="_Transparent_Rectangle_" data-name="&lt;Transparent Rectangle&gt;" class="cls-1" width="32" height="32"/>
        </svg>
    `);

    injectIcon('dxrd-svg-toolbox-revelation_reporting_reportcontrols_revxrsubreport', `
        <svg data-bind="svgAttrs" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 24 24" xml:space="preserve" xmlns:xlink="http://www.w3.org/1999/xlink">
            <path class="dxd-icon-fill" d="M21 3v19c0 .5-.5 1-1 1H4c-.5 0-1-.5-1-1V3c0-.5.5-1 1-1h3v2H5v17h14V4h-2V2h3c.5 0 1 .5 1 1zm-7-1V1c0-.6-.4-1-1-1h-2c-.6 0-1 .4-1 1v1H8v3h8V2h-2zm2 6H8v2h8V8zm0 6H8v-2h8v2zm0 4H8v-2h8v2z"></path>
        </svg>
    `);

    injectIcon('dxrd-svg-toolbox-revelation_reporting_revline', `
        <svg data-bind="svgAttrs" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 24 24" xml:space="preserve" xmlns:xlink="http://www.w3.org/1999/xlink">
            <path class="dxd-icon-fill" d="M21 18h-1.6L6 4.6V3c0-.5-.5-1-1-1H3c-.5 0-1 .5-1 1v2c0 .5.5 1 1 1h1.6L18 19.4V21c0 .5.5 1 1 1h2c.5 0 1-.5 1-1v-2c0-.5-.5-1-1-1z"></path>
        </svg>
    `);
}


const subreportControlsByReport: Record<string, XRSubreportViewModel[]> = {};
let initialized = false;

// This runs before every load of a report/subreport
export const beforeRender = (designer: JSReportDesigner) => {
    initialize(designer);
}

const initialize = (designer: JSReportDesigner) => {
    if (initialized)
        return;

    initialized = true;

    designer.designerModel.controls.subscribe((controls) => {
        ensureSubreportNameListeners(designer, controls);
    });

    const controls = designer.designerModel.controls();
    ensureSubreportNameListeners(designer, controls);

    designer.GetDesignerModel()._wizardRunner.registerCommand('DataSourceWizard', () => {
        window.dispatchEvent(new CustomEvent('datasource:edit', {
            detail: { reportGu: designer.GetCurrentTab().url().split('/')[0] }
        }));
    }, () => { /* This is the close callback, but it will be called immediately because we are breaking out of the normal wizard flow */ });

    window.addEventListener('datasource:saved', () => {
        designer.GetCurrentTab().refresh(false);
    });


}


const ensureSubreportNameListeners = (designer: JSReportDesigner, controls: any[]) => {
    const tab = designer.GetCurrentTab();
    if (!tab)
        return;

    const currentUrl = tab.url();
    const reportGu = currentUrl.split('/')[0];
    if (!reportGu)
        return;

    if (!subreportControlsByReport[currentUrl])
        subreportControlsByReport[currentUrl] = [];

    for (const control of controls) {
        const subreportControl = control.value;
        if (isSubreportControl(subreportControl)) {
            if (!subreportControlsByReport[currentUrl].includes(subreportControl)) {
                subreportControlsByReport[currentUrl].push(subreportControl);
                subscribeChanged(subreportControl.name, async ({ oldValue, newValue }) => {
                    const oldName = subreportControl.reportSourceUrl().split('/')[1] || oldValue;
                    await renameSubreport(reportGu, oldName, newValue);
                    subreportControl.reportSourceUrl(`${reportGu}/${newValue}`);
                })
            }
        }
    }
}

export const customizeToolbox = (designer: JSReportDesigner, e: { ControlsFactory: ControlsFactory }) => {
    const controlsFactory = e.ControlsFactory as ControlsFactory;
    const reportDataMemberInfo = controlsFactory.getPropertyInfo("DevExpress.XtraReports.UI.XtraReport", "DataMember");

    const subreportDataMemberInfo = {
        ...reportDataMemberInfo,
        propertyName: 'expression',
        modelName: '@DataMember',
        displayName: 'Data Member',
        expressionName: 'Data Member',
        defaultVal: '',
        localizationId: '',
    };

    // @ts-expect-error
    subreportDataMemberInfo.editor.extendedProperties = { path: '0.REV_REPORT' }

    const revSubreportInfo = controlsFactory.inheritControl('XRSubreport', {
        group: 'complex',
        defaultVal: { '@ControlType': customControls.subreport.fullType, '@SizeF': '400,50' },
        info: [ subreportDataMemberInfo ],
        popularProperties: ['expression'],
        // @ts-expect-error
        defaultBindingName: 'expression',
    });

    controlsFactory.registerControl(customControls.subreport.shortType, revSubreportInfo);
    controlsFactory.setExpressionBinding(customControls.subreport.shortType, 'expression', ['BeforePrint']);
    controlsFactory.setDisplayNameForExpression('expression', '', 'Data Member');

    (designer as unknown as JSReportDesigner).AddToPropertyGrid("Data", subreportDataMemberInfo);

    const subreportInfo = controlsFactory.getControlInfo('XRSubreport');
    subreportInfo.isToolboxItem = false;

    const lineInfo = controlsFactory.getControlInfo('XRLine');
    lineInfo.isToolboxItem = false;
}

export const componentAdded = (designer: JSReportDesigner, args: { Model: any }) => {
    if (!isSubreportControl(args.Model))
        return;

    const reportGU = designer.GetCurrentTab().url().split('/')[0];
    const subreportName = args.Model.name();
    const url = `${reportGU}/${subreportName}`;
    args.Model.reportSourceUrl(url);
}

export const renameSubreport = async (reportGu: string, oldName: string, newName: string) => {
    const root = rootUrl();
    await fetch(`${root}api/v1/subreports/rename`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ reportGu, oldName, newName }),
    });
}

export const customizeMenuActions = (ko: typeof import('knockout'), s: JSReportDesigner, e: { Actions: any[] }) => {
    document.getElementById('ASPxReportDesigner1')?.addEventListener('wheel', (event) => {
        const zoomFactor = 1.1;
        if (event.ctrlKey) {
            event.preventDefault();
            if (s.GetDesignerModel().designMode()) {
                const curz = s.GetDesignerModel().surface().zoom();
                const newz = event.deltaY < 0 ? curz * zoomFactor : curz / zoomFactor;
                s.GetDesignerModel().surface().zoom(newz);
            }
        }
    });

    window.addEventListener('beforeunload', (e) => {
        if (s.designerModel.isDirty()) {
            e.preventDefault();
        }
    })

    const isOverlapDetectionOn = ko.observable(false)

    e.Actions.splice(14, 0, {
        text: "Toggle Overlap Detection",
        imageTemplateName: "enable-overlap-detection",
        visible: true,
        disabled: false,
        hasSeparator: false,
        selected: isOverlapDetectionOn,
        clickAction: function () {
            isOverlapDetectionOn(!isOverlapDetectionOn())
            document.querySelector('body')?.classList.toggle('overlap-detection', isOverlapDetectionOn())
        }
    })

    const menuSave = e.Actions.find((a: { id: string }) => a.id === 'dxrd-save');
    e.Actions.splice(17, 0, {
        text: "Save",
        container: "toolbar",
        imageClassName: menuSave.imageClassName,
        imageTemplateName: menuSave.imageTemplateName,
        visible: true,
        disabled: menuSave.disabled,
        hasSeparator: true,
        clickAction: menuSave.clickAction,
    })

    document.addEventListener('keydown', e => {
        // Ctrl + S
        if (e.ctrlKey && e.key === 's') {
            e.preventDefault();
            menuSave.clickAction()
        }
    })

    e.Actions.splice(18, 0, {
        text: "Edit Data Source",
        imageTemplateName: "edit-data-source",
        visible: true,
        disabled: false,
        hasSeparator: false,
        clickAction: function () {
            window.dispatchEvent(new CustomEvent('datasource:edit', {
                detail: { reportGu: s.GetCurrentTab().url().split('/')[0] }
            }));
        }
    })

    const isFormatPaintActive = ko.observable(false)
    const currentFormat = ko.observable(null)
    const formatPaintStyle = ko.computed(() => isFormatPaintActive() ? 'fill: #3fb6f9' : 'fill: #606060')

    formatPaintStyle.subscribe((v) => {
        document.querySelector(`[aria-label="Format Paint"] > div > svg`)?.setAttribute('style', v)
    })

    let unsubscribeSelection: ko.Subscription

    e.Actions.splice(19, 0, {
        text: "Format Paint",
        imageTemplateName: "format-paint",
        visible: true,
        disabled: false,
        hasSeparator: true,
        clickAction: function () {
            if (isFormatPaintActive()) {
                isFormatPaintActive(false)
                currentFormat(null)

                if (unsubscribeSelection) {
                    unsubscribeSelection.dispose()
                }
            } else {
                if (s.designerModel.selection.selectedItems.length === 1) {
                    const ctrlModel = s.designerModel.selection.selectedItems[0].getControlModel()
                    if (ctrlModel && 'font' in ctrlModel && 'foreColor' in ctrlModel && 'backColor' in ctrlModel) {
                        const font = ctrlModel.font as ko.Observable<string> | ko.Computed<string>;
                        const foreColor = ctrlModel.foreColor as ko.Observable<string> | ko.Computed<string>;
                        const backColor = ctrlModel.backColor as ko.Observable<string> | ko.Computed<string>;
                        currentFormat({ font: font(), foreColor: foreColor(), backColor: backColor() });
                    }


                    isFormatPaintActive(true)

                    //@ts-expect-error
                    unsubscribeSelection = (s.designerModel.selection._selectedControls as ko.Observable<any[]>).subscribe(controls => {
                        if (isFormatPaintActive() && currentFormat()) {
                            for (const control of controls) {
                                const model = control.getControlModel()
                                model.font(currentFormat().font)
                                model.foreColor(currentFormat().foreColor)
                                model.backColor(currentFormat().backColor)
                            }
                        }
                    })
                }
            }

        }
    })


    const previewAction = e.Actions.find((a: { id: string }) => a.id === 'dxrd-preview')
    if (previewAction) {
        //Temporarily disable the preview button, report previews throw in the report designer. Will need a better model worked out for generating sample data
        previewAction.disabled = ko.pureComputed(() => true);
    }

    removeCommandById(e, 'dxrd-newreport');
    removeCommandById(e, 'dxrd-newreport-via-wizard');
    removeCommandById(e, 'dxrd-run-wizard');
    removeCommandById(e, 'dxrd-open-report');
    removeCommandById(e, 'dxrd-add-sql-datasource');
    removeCommandById(e, 'dxrd-add-multi-query-sql-datasource');
    removeCommandById(e, 'dxrd-localization-editor');
    removeCommandById(e, 'dxrd-save-as');
    removeCommandById(e, 'dxrd-scripts');
}

export const customizeLocalization = (designer: JSReportDesigner) => {
    designer.UpdateLocalization({
        'Add Data Source': 'Edit Data Source',
    })
}

function removeCommandById(e: { Actions: any[] }, id: string) {
    const idx = e.Actions.findIndex(a => a.id === id);
    if (idx >= 0) {
        e.Actions.splice(idx, 1);
    }
}

type CustomControlInfo = {
    shortType: string;
    fullType: string;
}

const customControls = {
    subreport: {
        shortType: 'Revelation.Reporting.ReportControls.RevXRSubreport',
        fullType: 'Revelation.Reporting.ReportControls.RevXRSubreport, Synergy.Reports, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null',
    },
    line: {
        shortType: 'Revelation.Reporting.RevLine',
        fullType: 'Revelation.Reporting.RevLine, Synergy.Reports, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null',
    }
} satisfies Record<string, CustomControlInfo>;

const subscribeChanged = <T,>(observable: ko.Observable<T> | ko.Computed<T>, callback: (event: { oldValue: T, newValue: T }) => void) => {
    let oldValue: T;
    observable.subscribe(_old => {
        oldValue = _old;
    }, null, 'beforeChange');

    observable.subscribe(_new => {
        callback({ oldValue, newValue: _new });
    });
};

const isSubreportControl = (control: any): control is XRSubreportViewModel => {
    return (control?.controlType === 'XRSubreport' || control?.controlType === customControls.subreport.shortType);
};

(window as any)['DXReportDesignerCallbacks'] = {
    ensureIcons,
    beforeRender,
    componentAdded,
    customizeMenuActions,
    customizeToolbox,
    customizeLocalization,
    renameSubreport,
}